import { CommonModule } from '@angular/common';
import { Component} from '@angular/core';

@Component({
  selector: 'app-error-display-banner',
  templateUrl: './error-display-banner.component.html',
  styleUrls: ['./error-display-banner.component.scss'],
  standalone: true,
  imports: [CommonModule]
})
export class ErrorDisplayBannerComponent {

}
